import Utilities from "./utilities";
import Agency from "./agency";

let stopFeature = null,
	stopInfowindow = null,
	overlay = null;

const $stopPanel = document.getElementById( 'tm__stop' ),
	$stopPanelName = $stopPanel.querySelector( 'h3' ),
	$dropdownDestination = document.getElementById( 'tm__destination' ),
	$stopPanelDayFilters = document.getElementById( 'tm__stop-day' ).querySelectorAll( 'input' ),
	$noArrivals = $stopPanel.querySelector( '.tm__no-arrivals' ),
	$stopPanelTimes = $noArrivals.parentNode,
	$stopPanelTimesScrollWrapper = $stopPanelTimes.closest( '.tm__stop-times' ),
	$routePanelStops = document.getElementById( 'tm__route-detail' ).querySelector( '.tm__stops' );

const Stop = {
	init: async ( tm ) => {
		Stop.initDaypicker();
		Stop.initStopInfowindow( tm );
		$stopPanel.querySelector( 'form' ).addEventListener( 'change', Stop.applyFilters );

		// overlay layer is used to calculate how to pan the map when an infowindow is opened
		overlay = new google.maps.OverlayView();
		overlay.draw = () => {
		};
		overlay.setMap( tm.map );

		// replace native scrollbar, because iOS insists on hiding it
		$stopPanelTimesScrollWrapper.fakeScroll()
	},

	updateBackButton: ( tm ) => {
		const $btn = $stopPanel.parentNode.querySelector( '.tm__back' );
		$btn.dataset.openPane = 'route|' + tm.visible.routeId;
	},

	openPanelStopDetail: async ( tm, stopId, stopName ) => {
		return new Promise( resolve => {
			Stop.updateBackButton( tm );

			Stop.getFeature( tm, stopId )
				.then( feature => {
					if ( !feature ) return;
					stopFeature = feature;

					Stop.updateVisibleStop( tm, stopId, stopName );
					Stop.openStopInfowindow( tm, feature );
					Stop.renderPaneStopDetail( tm );

					// revert style of all the visible agency's stops and highlight only this stop
					tm.stopLayers[tm.visible.agencyId].revertStyle();
					Stop.highlightFeatureMarker( tm, feature );
					resolve();
				} )
				.catch( err => {
					console.error( 'Error:', err );
					resolve();
				} );
		} );
	},

	stopHoveredInMap: ( e, tm, mouseover = false ) => {
		const stopId = parseInt( e.feature.getProperty( 'stop' ), 10 ),
			$button = stopId ? $routePanelStops.querySelector( 'button[data-open-pane="stop|' + stopId + '"]' ) : false;

		if ( mouseover ) {
			if ( $button ) {
				$button.classList.add( "hover" );
			}

			Stop.highlightFeatureMarker( tm, e.feature );
		} else {
			if ( $button ) {
				$button.classList.remove( "hover" );
			}

			if ( stopId && stopId === tm.visible.stopId ) return;
			tm.stopLayers[tm.visible.agencyId].revertStyle( e.feature );
		}
	},

	stopHoveredInRoutePanel: ( e, tm, mouseover = false ) => {
		const pane = e.target.dataset.openPane.split( '|' );
		if ( !pane ) return;

		const stopId = parseInt( pane[1], 10 );
		if ( !stopId ) return;

		Stop.getFeature( tm, stopId )
			.then( feature => {
				if ( !feature ) return;

				if ( mouseover ) {
					Stop.highlightFeatureMarker( tm, feature );
				} else {
					if ( tm.visible.stopId === stopId ) return; // stop was clicked during mouseover which results in mouseout; don't revert style
					tm.stopLayers[tm.visible.agencyId].revertStyle( feature );
				}
			} )
			.catch( err => {
				console.error( 'Error:', err );
			} );
	},

	initDaypicker: () => {
		const $fieldset = $stopPanel.querySelector( ".tm__stop-day" ),
			$btns = [...$fieldset.querySelectorAll( 'input[type="radio"]' )];
		let current = 0;

		// synchronize clicking the labels directly and clicking the Next button
		$fieldset.addEventListener( 'click', ( e ) => {
			current = $btns.findIndex( btn => btn.checked );
			if ( e.target.closest( 'button' ) ) {
				current = (current + (e.target.dataset.type === "prev" ? 6 : 1)) % 7; // increment to prev or next day
				$btns[current].checked = true;
				$fieldset.dispatchEvent( new CustomEvent( "change", {bubbles: true} ) );
			}
			$fieldset.dataset.selected = current;
		} );
	},

	getFeature: async ( tm, stopId ) => {
		let feature = null;

		await Agency.preloadAgencyStops( tm );

		if ( stopId && tm.stopLayers[tm.visible.agencyId] ) {
			tm.stopLayers[tm.visible.agencyId].forEach( ( elt ) => {
				if ( elt.getProperty( 'stop' ) === stopId && elt.getProperty( 'route' ) === tm.visible.routeId ) {
					feature = elt;
				}
			} );
		}

		return feature;
	},

	highlightFeatureMarker: ( tm, feature ) => {
		const fillColor = Utilities.getMarkerColor( 'route_' + tm.visible.routeId );
		const svg = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="' + fillColor + '">'
			+ '<path fill-opacity=".5" d="M32 16a16 16 0 0 1-16 16A16 16 0 0 1 0 16 16 16 0 0 1 16 0a16 16 0 0 1 16 16Z" />'
			+ '<path d="M24 16a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8z"/>'
			+ '</svg>';
		tm.stopLayers[tm.visible.agencyId].overrideStyle( feature, {
			icon: {
				url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent( svg ),
				anchor: new google.maps.Point( 16, 16 ),
				scaledSize: new google.maps.Size( 32, 32 )
			}
		} );
	},

	initStopInfowindow: ( tm ) => {
		// set up the infowindow and have it close when the map is clicked outside of it
		stopInfowindow = new google.maps.InfoWindow( {
			maxWidth: 310,
			pixelOffset: new google.maps.Size( 0, - 20 )
		} );

		google.maps.event.addListener( tm.map, 'click', () => Stop.closeStopInfowindow() );
		stopInfowindow.addListener( 'closeclick', () => Stop.closeStopInfowindow() );
	},

	// adds/removes a custom class on the map, so we can style just the stop infowindow and not any other infowindows (e.g. from the trip planner)
	addInfowindowOpenClass: ( open = true ) => {
		if ( open )
			document.getElementById( 'tm__map' ).classList.add( 'has-open-stop-infowindow' );
		else
			document.getElementById( 'tm__map' ).classList.remove( 'has-open-stop-infowindow' );
	},

	openStopInfowindow: async ( tm, feature ) => {
		Stop.addInfowindowOpenClass();

		const pos = feature.getGeometry().get(),
			streetview = await Stop.maybeRenderStreetviewImage( pos ),
			html = streetview + `
			<div id="tm__agency--stop" class="tm__agency--stop">
				<div class="stop-name">${feature.getProperty( 'name' )}</div>
				<div class="stop-id">${tmVars.translations.stop} #${feature.getProperty( 'stop' )}</div>
			</div>`;

		stopInfowindow.setContent( html );
		stopInfowindow.setPosition( pos );
		stopInfowindow.open( {map: tm.map, shouldFocus: false} );
		Stop.panMapToInfowindow( tm );
	},

	// closes the infowindow and clears the visible feature; does not change the visible stop id/name
	closeStopInfowindow: () => {
		Stop.addInfowindowOpenClass( false );
		stopInfowindow.close();
		stopFeature = null;
		return true;
	},

	getStopInfowindow: () => {
		return stopInfowindow;
	},

	maybeRenderStreetviewImage: ( pos ) => {
		return new Promise( ( resolve ) => {
			let url = 'https://maps.googleapis.com/maps/api/streetview/metadata?location=' + pos.lat() + ',' + pos.lng() + '&size=310x155&source=outdoor&key=' + tmVars.apiKey;
			fetch( url ).then( ( response ) => {
				return response.ok ? response.json() : Promise.reject( response );
			} ).then( ( data ) => {
				if ( data.status === 'OK' ) {
					let imgSrc = 'https://maps.googleapis.com/maps/api/streetview?location=' + pos.lat() + ',' + pos.lng() + '&size=310x155&source=outdoor&key=' + tmVars.apiKey;

					resolve( '<img class="tm__agency--stop-img" src="' + imgSrc + '" alt="Google Street View image of stop" width="310" height="155">' );

				}
				resolve( '' );
			} ).catch( ( err ) => {
				console.error( 'Error:', err );
				resolve( '' );
			} );
		} );
	},

	panMapToInfowindow: ( tm ) => {
		const panMap = () => {
			if ( !stopFeature ) return;

			// sidebar and infowindow width (plus extra padding), in pixels
			const sidebarWidth = Utilities.isDesktop() ? 475 : 0,
				infowindowWidth = 350,
				projection = overlay.getProjection();

			if ( !projection ) return;

			// the marker's current position, in pixels
			const marker = projection.fromLatLngToContainerPixel( stopFeature.getGeometry().get() );

			// southwest corner and northeast corners of map, in pixels
			const cornerSW = projection.fromLatLngToContainerPixel( tm.map.getBounds().getSouthWest() ),
				cornerNE = projection.fromLatLngToContainerPixel( tm.map.getBounds().getNorthEast() );

			// default: don't pan
			let offsetY = cornerSW.y / 2,
				offsetX = cornerNE.x / 2;

			// adjust horizontally if infowindow is hidden under sidebar
			if ( sidebarWidth + infowindowWidth / 2 - marker.x > 0 ) {
				offsetX = offsetX - (sidebarWidth + infowindowWidth / 2 - marker.x);
			}

			tm.map.panTo( projection.fromContainerPixelToLatLng( new google.maps.Point( offsetX, offsetY ) ) );
		};

		if ( tm.isIdle ) {
			panMap();
		} else {
			google.maps.event.addListenerOnce( tm.map, 'idle', () => {
				panMap();
			} );
		}
	},

	hideVisibleStops: ( tm ) => {
		if ( !Object.keys( tm.stopLayers ).length ) return;
		for ( const agencyId in tm.stopLayers ) {
			tm.stopLayers[agencyId].setMap( null );
		}
	},

	revertStopStyling: ( tm ) => {
		if ( !Object.keys( tm.stopLayers ).length ) return;
		for ( const agencyId in tm.stopLayers ) {
			tm.stopLayers[agencyId].revertStyle();
		}
	},

	renderPaneStopDetail: ( tm ) => {
		if ( !tm.visible.routeId || $stopPanel.dataset.loading === 'true' ) {
			return;
		}

		$stopPanelName.innerHTML = Utilities.escapeHtml( tm.visible.stopName );

		$stopPanel.dataset.loading = 'true';

		let url = tmVars.gtfsDir + 'timetables/route_' + tm.visible.routeId + '.csv';
		Utilities.cachedFetch( url ).then( ( response ) => {
			return response.ok ? response.text() : Promise.reject( response );
		} ).then( ( data ) => {
			$stopPanel.removeAttribute( 'data-loading' );
			const destinations = Stop.renderTimetable( tm, data );
			Stop.renderDestinationDropdown( destinations )
			Stop.applyFilters();
		} ).catch( ( err ) => {
			console.error( 'Error:', err );
		} );
	},

	renderTimetable: ( tm, timetableData ) => {
		let timetableStr = '',
			destinations = {};

		let lines = timetableData.split( '\n' );
		lines = lines.filter( ( line ) => {
			return line.trim() !== "";
		} );

		for ( let line of lines ) {
			const value = line.trim().split( ',' );
			if ( value[0] !== tm.visible.stopId.toString() ) continue; // ignore times for other stops
			timetableStr += `<li data-dest="${Utilities.escapeHtml( value[1] )}"
				${parseInt( value[4], 10 ) ? ' data-mo="1"' : ''}
				${parseInt( value[5], 10 ) ? ' data-tu="1"' : ''}
				${parseInt( value[6], 10 ) ? ' data-we="1"' : ''}
				${parseInt( value[7], 10 ) ? ' data-th="1"' : ''}
				${parseInt( value[8], 10 ) ? ' data-fr="1"' : ''}
				${parseInt( value[9], 10 ) ? ' data-sa="1"' : ''}
				${parseInt( value[10], 10 ) ? ' data-su="1"' : ''}
				>${Stop.convertTo12HourFormat( value[3] )}</li>`;
			destinations[value[1]] = value[2];
		}

		// remove previous nodes and insert new ones
		while ( $stopPanelTimes.children.length > 1 ) {
			$stopPanelTimes.removeChild( $stopPanelTimes.lastElementChild );
		}
		$stopPanelTimes.insertAdjacentHTML( 'beforeend', timetableStr );

		return destinations;
	},

	renderDestinationDropdown: ( destinations ) => {
		// store the previous destination, so we can restore it if it still exists after updating the dropdown options
		let destinationSelected = $dropdownDestination.value;

		// populate the destination dropdown with all the unique destinations from the data
		const destinationsCount = Object.keys( destinations ).length;
		let destinationStr = '<option value="">' + tmVars.translations.na + '</option>';
		if ( destinationsCount ) {
			destinationStr = '';
			for ( const key in destinations ) {
				let destination = destinations[key];

				// remove quotes from the CSV
				if ( destination[0] === '"' && destination[destination.length - 1] === '"' ) {
					destination = destination.substring( 1, destination.length - 1 );
				}

				// populate empty destination strings
				if ( destination === '' ) {
					destination = tmVars.translations.na;
				}

				destinationStr += '<option value="' + Utilities.escapeHtml( key ) + '">' + Utilities.escapeHtml( destination ) + '</option>';
			}
		}
		$dropdownDestination.innerHTML = destinationStr;
		$dropdownDestination.disabled = destinationsCount < 2; // disable dropdown if only one destination choice

		// select the previously-selected option if possible
		const $prevSelected = $dropdownDestination.querySelector( '[value="' + destinationSelected + '"]' );
		if ( $prevSelected ) {
			$prevSelected.selected = true;
		}
	},

	// adds the class "next" to the next arrival time and scrolls the list to display it
	highlightNextArrival: () => {
		const currentTime = Stop.getDecimalTime();
		let $next = null;

		for ( const $time of $stopPanelTimes.children ) {
			$time.classList.remove( 'next' );
			if ( $time.hidden ) continue;

			const time = $next ? false : Stop.getDecimalTime( $time.textContent );
			if ( time && time >= currentTime ) {
				$next = $time;
			}
		}

		if ( !$next ) $next = $stopPanelTimes.querySelector( ':not([hidden])' );
		$next.classList.add( 'next' );
		$noArrivals.parentNode.parentNode.scrollTop = $next.offsetTop - $stopPanelTimes.offsetTop;
	},

	// convert a 24-hour time into a 12-hour time with AM/PM suffix
	convertTo12HourFormat: ( time24 ) => {
		const timeSplit = time24.split( ":" ),
			hours = parseInt( timeSplit[0], 10 ),
			minutes = parseInt( timeSplit[1], 10 ),
			suffix = hours >= 12 ? " PM" : " AM";
		return (hours % 12 || 12) + ":" + minutes.toString().padStart( 2, "0" ) + suffix;
	},

	getDecimalTime: ( time ) => {
		if ( !time ) {
			const now = new Date();
			return now.getHours() + now.getMinutes() / 100;
		}

		const timeSplit = time.split( /[:\s]+/ ),
			hours = parseInt( timeSplit[0], 10 ),
			minutes = parseInt( timeSplit[1], 10 ),
			ampm = timeSplit[2];

		if ( !hours || Number.isNaN( minutes ) || !ampm ) return false;

		let adjust = 0;
		if ( ampm === 'PM' && hours !== 12 ) adjust = 12;
		else
			if ( ampm === 'AM' && hours === 12 ) adjust = - 12;

		return (hours + adjust) + minutes / 100;
	},

	applyFilters: () => {
		let destinationSelected = $dropdownDestination.value,
			day = [...$stopPanelDayFilters].find( c => c.checked ).value;
		Stop.filterArrivals( $stopPanelTimes, $noArrivals, destinationSelected, day );
		Stop.highlightNextArrival();
	},

	filterArrivals: ( $elt, $noArrivals, destination, day ) => {
		let visibleCount = 0;
		$noArrivals.hidden = false;

		if ( !destination || !day ) return;

		for ( let child of $elt.children ) {
			if ( !child.dataset.dest ) continue; // skip $noArrivals

			if ( child.dataset.dest === destination && child.dataset[day] === "1" ) {
				visibleCount ++;
				child.hidden = false;
				$noArrivals.hidden = true;
			} else
				child.hidden = true;
		}

		// TODO don't hardcode, this is terrible
		if ( visibleCount > 5 ) {
			$stopPanelTimesScrollWrapper.classList.add( "is-scrollable" );
		} else {
			$stopPanelTimesScrollWrapper.classList.remove( "is-scrollable" );
		}

		// get the fakescroll scrollbar to recompute its size
		$noArrivals.dispatchEvent( new MouseEvent( 'mouseenter', {'bubbles': true} ) );
	},

	updateVisibleStop: ( tm, stopId, stopName = null ) => {
		stopId = parseInt( stopId, 10 );
		tm.visible.stopId = stopId ? stopId : null;
		tm.visible.stopName = stopName ? stopName : Stop.getStopName( stopId );
	},

	getStopName: ( stopId ) => {
		if ( !stopId ) return null;
		const $button = $routePanelStops.querySelector( 'button[data-open-pane="stop|' + stopId + '"]' );
		return $button ? $button.textContent : null;
	},
}

export default Stop;
